import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from "@mui/material";
import { getTeamsOfCaptain } from "../../api/team.api";
import { useAuth } from "../../context/auth.context";
import { join } from "../../api/tournament.api";
import { useSnackbar } from "../../context/snackbar.context.js";

const ChooseTeamModal = ({ open, handleClose, tournament, refresh }) => {
  const [teams, setTeams] = useState("");
  const [error, setError] = useState("");
  const auth = useAuth();
  const showSnackbar = useSnackbar();

  const [formData, setFormData] = useState({
    id: "",
  });

  const initialFormData = useMemo(
    () => ({
      id: "",
    }),
    []
  );

  useEffect(() => {
    getTeamsOfCaptain(auth.user.id)
      .then((response) =>
        setTeams(
          response.data.filter(
            (team) => team.members.length === tournament.teamSize
          )
        )
      )
      .catch((e) => console.log(e));
  }, [auth, initialFormData]);

  const onSubmit = (e) => {
    join(tournament.id, formData.id)
      .then((result) => {
        if (!result.data) {
          showSnackbar("Could not join!", "error");
        } else {
          showSnackbar("Joined successfully!", "success");
        }
        handleClose();
        refresh();
      })
      .catch((e) => setError(e.response.data.reason));
    setFormData(initialFormData);
  };

  const onClose = () => {
    setFormData(initialFormData);
    handleClose();
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => {
      const updatedFormData = {
        ...prevState,
        [name]: value,
      };
      return updatedFormData;
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Choose your Team</Typography>
          <div>
            <FormControl fullWidth>
              {teams && teams.length > 0 && (
                <InputLabel id="select-team-label">Team</InputLabel>
              )}
              {teams && teams.length > 0 && (
                <Select
                  labelId="select-team-label"
                  id="id"
                  name="id"
                  value={formData.id}
                  label="Team"
                  onChange={handleChange}
                >
                  {teams.map((team) => (
                    <MenuItem key={team.id} value={team.id}>
                      {team.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
              {teams && teams.length === 0 && (
                <>
                  You are not the captain of a team matching the requirements.
                </>
              )}
            </FormControl>
          </div>
          {error && (
            <Alert
              severity="error"
              onClose={() => {
                setError("");
              }}
            >
              {error}
            </Alert>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit} disabled={formData.id === ""}>
          Join
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChooseTeamModal;
